<header class="main__content__header modal-header">
  <h2 class="modal-title">Detalhes do Reembolso - {{details.ansProtocol}} </h2>
  <a class="header__btn__close" (click)="activeModal.close(true)">
    <span aria-hidden="true">X</span>
  </a>
</header>
<main class="main__content__modal modal-body">
  <section class="modal__main__dados_usuario content__modal__header">
    <div class="pl-0 pr-0 mb-3 row">
      <div class="col-xl-6 mb-1">
        <span class="content__modal__title">Protocolo de atendimento</span>
        <p class="content__modal__valor">{{details.ansProtocol}}</p>
      </div>
      <div class="col-xl-6 mb-1">
        <span class="content__modal__title">Beneficiário</span>
        <p class="content__modal__valor">{{details.beneficiaryName}}</p>
      </div>
      <div class="col-sm-12 col-xl-6">
        <span class="content__modal__title">Data e hora da solicitação</span>
        <p class="content__modal__valor">{{ details.requestDate | date:'dd/MM/yyyy | HH:mm' || ' - '}}</p>
      </div>
      <div class="col-sm-12 col-xl-6">
        <span class="content__modal__title">Tipo de reembolso</span>
        <p class="content__modal__valor">{{ details.refundType }}</p>
      </div>
      <div class="col-sm-12 col-xl-6">
        <span class="content__modal__title">Valor solicitado</span>
        <p class="content__modal__valor">{{details.requestedValue | number: "1.2-2":"pt-br"}}</p>
      </div>
      <br>
      <section class="row col-12 px-2 ">
        <div class="col-sm-12 col-xl-6 px-1">
          <span class="content__modal__title">CPF do Profissional</span>
          <p class="content__modal__valor">{{details.executor | cpfCnpj}}</p>
        </div>
        <div class="col-sm-12 col-xl-6 px-1">
          <span class="content__modal__title">Conselho Profissional</span>
          <p class="content__modal__valor">{{details.professionalCouncil}}</p>
        </div>
      </section>
      <br>
      <section class="row col-12 px-2 ">
        <div class="col-sm-12 col-xl-3 px-1">
          <span class="content__modal__title">Tipo de Documento</span>
          <p class="content__modal__valor">{{details.documentType}}</p>
        </div>
        <div class="col-sm-12 col-xl-2 px-1">
          <span class="content__modal__title">Nº da Nota</span>
          <p class="content__modal__valor">{{details.documentNumber}}</p>
        </div>
        <div class="col-sm-12 col-xl-3 px-1">
          <span class="content__modal__title">Data de Emissão</span>
          <p class="content__modal__valor">{{details.documentEmissao | date:'dd/MM/yyyy | HH:mm' || ' - '}}</p>
        </div>
        <div class="col-sm-12 col-xl-3 px-1">
          <span class="content__modal__title">CNPJ</span>
          <p class="content__modal__valor">{{details.documentCpfCnpj | cpfCnpj}}</p>
        </div>
      </section>
      <br>
      <div class="col-12 mb-1">
        <span class="content__modal__title">Observações</span>
        <p class="content__modal__valor">{{ details.comments || '-'}}</p>
      </div>
      <br>
      <div class="col-12 mb-1" *ngIf="details.reason">
        <span class="content__modal__title">Comentários da Fundação Copel</span>
        <p class="content__modal__valor">{{ details.reason || '-'}}</p>
      </div>
      <section class="row col-12 px-2 content-resultado">
        <div class="col-sm-12 col-xl-3 px-1">
          <span class="content__modal__title">Situação</span>
          <p class="content__modal__valor">
            <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 10" />
              <circle cx="10" cy="10" r="4" [attr.fill]="getRefundStatusColor(details.refundStatusId)" />
            </svg>
            {{details.refundStatus}}
          </p>
        </div>
        <div class="col-sm-12 col-xl-2 px-1">
          <span class="content__modal__title">Última atualização</span>
          <p class="content__modal__valor">{{details.updateDate | date: "dd/MM/yyyy | HH:mm"}}</p>
        </div>
        <div class="col-sm-12 col-xl-3 px-1" *ngIf="details.paymentDate">
          <span class="content__modal__title">Data de crédito</span>
          <p class="content__modal__valor">{{details.paymentDate | date:'dd/MM/yyyy | HH:mm' || ' - '}}</p>
        </div>
        <div class="col-sm-12 col-xl-3 px-1" *ngIf="details.authorizedValue">
          <span class="content__modal__title">Valor aprovado</span>
          <p class="content__modal__valor">{{details.authorizedValue | number: "1.2-2":"pt-br" || '-'}}</p>
        </div>
      </section>
    </div>
  </section>
</main>